module.exports = __webpack_public_path__ + "static/media/verdata_hires_logo.5d2b689e.png";